<template>
  <div class="rule-root">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px`">
      <van-nav-bar class="van-bar" :title="$t('lang.ActCommon.k009')" left-arrow @click-left="goPrevious">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />
        </template>
      </van-nav-bar>
    </div>

    <div class="bg-block">
      <div class="item-block">
        <div class="item-txt">1. {{ $t('lang.NewguyWheelPan.k009') }}</div>
        <br />
        <div class="item-txt">2. {{ $t('lang.NewguyWheelPan.k010') }}</div>
        <br />
        <div class="item-txt">3. {{ $t('lang.NewguyWheelPan.k011') }}</div>
        <br />
        <div class="item-txt">4. {{ $t('lang.NewguyWheelPan.k012') }}</div>
        <br />
        <div class="item-txt">5. {{ $t('lang.NewguyWheelPan.k013') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
}
</script>

<style lang="less" scoped>
img:not([src]) {
  opacity: 0;
}

.rule-root {
  width: 100%;
  min-height: 100vh;
  background: #ffdc6a;

  .custom-nav-block {
    background: #ffdc6a;
  }

  .bg-block {
    padding: 35px 16px;

    .item-block {
      width: 100%;
      min-height: 500px;
      padding: 16px;
      margin-bottom: 16px;
      border-radius: 12px;
      background: #fffcf0;

      .item-txt {
        width: 323px;
        line-height: 22px;
        font-family: 'TikTokSans-Regular';
        font-size: 16px;
        color: #222222;
        margin-top: 8px;
      }
    }
  }
}

::v-deep .van-nav-bar__title {
  font-size: 17px;
  font-family: 'Inter-Regular';
  font-weight: 600;
  color: #222222;
}
</style>
